import React, { useState, useEffect, useRef } from 'react'

import { useHistory } from "react-router-dom"

import { Box, FormControl, InputLabel, Select, MenuItem, Button, Typography } from '@mui/material'
import './styles.css'
import GraphToolbar from '../default-toolbar'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { graph_theme } from '../default-toolbar'
import { convert_time } from '../default-toolbar'
import { parseStatus, parseUsed } from '../../../../Crm/TabTables/NotificationTable'

import LoadingButton from '@mui/lab/LoadingButton';

import { exportHtmlToImage } from "../../../../../utils/exportHtmlToImage";

import EyeIcon from '@mui/icons-material/Visibility';
import ExportIcon from '@mui/icons-material/Download';

import PieChart from "../../../../D3/PieChart";

const translations = {
  'SUCCESS': 'SUCESSO',
  'ERROR': 'ERRO',
  'FAILURE': 'ERRO',
  'CANCEL': 'ERRO',
  'WAITING': 'PENDENTE',
  'NOTSENT': 'NÃO ENVIADA',
  'RESENT': 'REENVIADO',
  0: 'Não',
  1: 'Sim',
  2: 'Visualizada'
}

const ActiveMessages = ({ data, option, filters, periodText }) => {

  const history = useHistory()

  const columns = graph => {
    const columns = []
    columns.push({
      field: 'status',
      headerName: 'Status',
      flex: .5,
      renderCell: parseStatus
    })
    columns.push({
      field: 'used',
      headerName: 'Respondida',
      flex: .5,
      renderCell: parseUsed
    })
    columns.push({
      field: 'count',
      headerName: 'Quantidade',
      flex: .5
    })
    columns.push({
      field: 'actions',
      headerName: 'Ações',
      flex: .25,
      renderCell: (params) => (
        <Box>
          <Button className="action-button"
            onClick={() => {
              let startDate, endDate;
              if (filters.type === 'range') {
                startDate = filters.range_ini.format('YYYY-MM-DDTHH:mm');
                endDate = filters.range_end.format('YYYY-MM-DDTHH:mm');
              } else if (filters.type === 'month') {
                startDate = filters.month.startOf('month').format('YYYY-MM-DDTHH:mm');
                endDate = filters.month.endOf('month').format('YYYY-MM-DDTHH:mm');
              } else if (filters.type === 'day') {
                startDate = filters.day.startOf('day').format('YYYY-MM-DDTHH:mm');
                endDate = filters.day.endOf('day').format('YYYY-MM-DDTHH:mm');
              }

              const encodedDateRange = `${encodeURIComponent(startDate)},${encodeURIComponent(endDate)}`
              history.push(`chat?selectedTab=notifications&status=${encodeURIComponent(translations[params.row.status])}&dateRange=${encodedDateRange}`)
              
            }}>
            <EyeIcon />
          </Button>
        </Box>
      )
    })
    return columns
  }

  const [statusData, setStatusData] = useState([])
  const [usedData, setUsedData] = useState([])
  const [dataType, setDataType] = useState("number")

  const containerRef = useRef(null)

  const handleStatusData = (data) => {
    const statuses = {}
    data.rows?.forEach((row) => {
      const status = translations[row.status]
      if (!(status in statuses))
        statuses[status] = 0
      statuses[status] += row.count
    })
    setStatusData(Object.keys(statuses).map((key) => ({
      label: key,
      value: statuses[key]
    })))
  }

  const handleUsedData = (data) => {
    const used = {}
    data.rows?.forEach((row) => {
      if (row.status === 'SUCCESS') {
        const status = (row.used === 1) ? 'RESPONDIDA' : (row.used === 2) ? 'VISUALIZADA' : 'NÃO RESPONDIDA'
        if (!(status in used))
          used[status] = 0
        used[status] += row.count
      }
    })
    setUsedData(Object.keys(used).map((key) => ({
      label: key,
      value: used[key]
    })))
  }

  useEffect(() => {
    handleStatusData(data)
    handleUsedData(data)
  }, [data])

  return (
    <Box className='graph-main-divisor'>
      <Box className='graph-main-table'>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={graph_theme}>
            <DataGridPro
              density='compact'
              columns={columns(option)}
              rows={data?.rows.map((r, index) => ({ ...r, id: index + 1 }))}
              hideFooter={true}
              components={{
                Toolbar: GraphToolbar
              }}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
      <Box className='graph-main-dashboards'>
        <Box className='graph-time-rows'>
          {data.rows?.length !== 0 &&
            <>
              <Box sx={{ position: 'absolute', right: '0' }}>
                <FormControl sx={{ width: '200px', position: 'absolute', right: '2rem', zIndex: 1 }}>
                  <InputLabel id="sankey-type-label">Tipo</InputLabel>
                  <Select
                    size="small"
                    labelId="sankey-type-label"
                    id="demo-simple-select"
                    value={dataType}
                    label="Tipo"
                    onChange={(event) => setDataType(event.target.value)}
                  >
                    <MenuItem value={"number"}>Número</MenuItem>
                    <MenuItem value={"percentage"}>Percentual</MenuItem>
                  </Select>
                </FormControl>
                <LoadingButton startIcon={<ExportIcon />}
                  sx={{ position: 'absolute', right: '2rem', top: '3rem', zIndex: 1 }}
                  onClick={() => exportHtmlToImage(containerRef.current)}
                >
                  Exportar
                </LoadingButton>
              </Box>
              <Box className='new-graphs-wrapper'>
                <Box ref={containerRef} className='chats-channel-container' style={{ width: "100%", height: "100%", padding: "1rem", position:'relative' }}>
                  <img style={{ width: '10rem', display: 'none', position: 'absolute', right: 0 }} src="/static/media/kwik_color.f6459d28.png" alt="logo" class="logo" id="logo" className='showcopyright'></img>
                  <Typography variant="subtitle1">Disparos ativos (notificações WhatsApp), {periodText}</Typography>
                  <Box className='chats-channel-first-row'>
                    <PieChart label='Status' data={statusData} type={dataType} legendPosition="right" />
                    <PieChart label='Respostas' data={usedData} type={dataType} legendPosition="right" />
                  </Box>
                  <Typography sx={{ display: 'none', position: 'absolute', bottom: 0 }} variant="body2" align="center" className='showcopyright'>
                    Copyright (c) {new Date().getFullYear()} - Instant Solutions Tecnologia e Informática Ltda.
                  </Typography>
                </Box>
              </Box>
            </>
          }
        </Box>
      </Box>
    </Box>
  )
}

export default ActiveMessages
